import React from "react"
import Provider from "./Provider"
import Router from "./Router"

const App = () => (
  <Provider>
    <Router />
  </Provider>
)

export default App



// WEBPACK FOOTER //
// ./src/App.js